import script from "./PaymentStatusChip.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusChip.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusChip.vue?vue&type=style&index=0&id=4fbb572b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fbb572b"]])

export default __exports__